"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _list = _interopRequireDefault(require("@site/pattern-library-core/list"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _addToCart = _interopRequireDefault(require("../../../elements/buttons/add-to-cart"));
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
var _videoPlayButton = _interopRequireDefault(require("../../../elements/buttons/video-play-button"));
var _settings = require("@site/pattern-library-core/settings");
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c1u0aby1",
  vars: {
    "c1u0aby1-1": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : _intents.default.ux.box.backgroundColor]
  }
});
const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineContainer",
  class: "pl-h5urphh",
  vars: {
    "h5urphh-1": [({
      textAlign
    }) => textAlign ?? 'start']
  }
});
const ListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ListContainer",
  class: "pl-lkab0ef"
});

/**
 * RTBListSection Component.
 * @module RTBListSection
 *
 * @param {Object} props React props
 * @param {String} props.id Identifier
 * @param {Object} props.headlineContent Headline
 * @param {Array} props.ctas Cta
 * @param {Array} props.items List Items
 * @param {String} props.iconColor Icon
 * @param {String} props.iconType Icon
 * @param {String} props.backgroundColor Background Color
 * @param {Boolean} props.invert Opposite Theme
 * @param {String} props.partial Theme partial
 * @param {String} props.position Reversed Layout
 * @param {String} props.listType List Type
 * @param {string} props.verticalMargin Vertical Spacing value
 * @param {string} props.verticalPadding Vertical Inner Spacing value
 * @param {Object} props.priceLockup priceLockup
 * @returns {React.ReactElement} RTBListSection Component
 * @public
 */

function RTBListSection({
  _name,
  ctas,
  items,
  iconType,
  backgroundColor = {
    intent: 'ux.actionControl.backgroundColor'
  },
  invert,
  partial = invert ? 'dark1' : '',
  position,
  listType = 'icons',
  verticalMargin = 'none',
  verticalPadding = 'small',
  useHowToMarkup = false,
  priceLockup,
  ...headlineContent
}) {
  const {
    textAlign
  } = headlineContent;
  const schemaAttributes = (0, _settings.getSchemaAttributes)();
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    dataCy: "rtb-list-section",
    _name: _name,
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding,
    partial: "boxRadiusLarge"
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-cy": "container"
  }, useHowToMarkup ? schemaAttributes.howTo : null), /*#__PURE__*/_react.default.createElement(Container, {
    backgroundColor: partial ? _intents.default.ux.box.backgroundColor : (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    "data-partial": partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(HeadlineContainer, {
    "data-position": position,
    "data-cy": "headline-container",
    textAlign: textAlign
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, headlineContent, {
    textAlign: textAlign ? textAlign : 'start',
    ctas: ctas && /*#__PURE__*/_react.default.createElement(_index2.default, {
      actionsLayout: "button-set",
      ctas: ctas
    }),
    itemPropHeading: useHowToMarkup ? schemaAttributes.name.itemProp : null,
    itemPropDescription: useHowToMarkup ? schemaAttributes.description.itemProp : null,
    priceLockup: priceLockup
  }))), /*#__PURE__*/_react.default.createElement(ListContainer, {
    "data-position": position,
    "data-cy": "list-container"
  }, /*#__PURE__*/_react.default.createElement(_list.default, {
    items: items,
    iconColor: _intents.default.ux.box.foregroundColor,
    iconType: iconType,
    listType: listType,
    useHowToMarkup: useHowToMarkup
  })))));
}
var _default = exports.default = RTBListSection;
RTBListSection.propTypes = {
  _name: _propTypes.default.string,
  ctas: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_addToCart.default.propTypes), _propTypes.default.shape(_videoPlayButton.default.propTypes), _propTypes.default.shape(_inputBar.default.propTypes)])),
  iconType: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.object),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  position: _propTypes.default.string,
  listType: _propTypes.default.oneOf(['icons', 'numbers']),
  useHowToMarkup: _propTypes.default.bool,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};